/** Index of the quote closing the literal that opens at `open`, escapes honoured. */
export function endOfStringLiteral(source: string, open: number): number {
  const quote = source[open];
  for (let at = open + 1; at < source.length; at += 1) {
    if (source[at] === "\\") at += 1;
    else if (source[at] === quote) return at;
  }
  return source.length;
}
